import React, { useState, useEffect } from 'react';

import { Link, navigate } from 'gatsby';
import logo from '../assets/images/new/muriel.jpg';
import reaImg from '../assets/images/new/rea.jpg';
import etudeImg from '../assets/images/new/etudes.jpg';
import aboutImg from '../assets/images/new/contact.jpg';
import actuImg from '../assets/images/new/actu.jpg';
import NavFlex from '../styles/NavStyle';

function LiLink({ urlPath, textInsert, imgUrl }) {
  const redirection = () => {
    // setShowNav(false);
  };

  return (
    <li>
      <Link
        to={`/${urlPath}`}
        className={urlPath}
        onTouchStart={() => {
          navigate(`/${urlPath}`);
        }}
        onTouchEnd={() => redirection()}
      >
        {imgUrl ? (
          <img src={imgUrl} alt="" className="vignette" />
        ) : (
          <p>{textInsert}</p>
        )}
      </Link>
    </li>
  );
}

export default function Nav({ img, isBig, urlPath }) {
  const checkForNavLinkFocus = () => {
    if (/realisation/.test(urlPath)) {
      return 'realisations';
    }
    if (/etude/.test(urlPath)) {
      return 'etudes';
    }
    if (/actu/.test(urlPath)) {
      return 'actualités';
    }
    if (/infos/.test(urlPath)) {
      return 'infos';
    }
    if (/contact/.test(urlPath)) {
      return 'infos';
    }
    if (/biographie/.test(urlPath)) {
      return 'infos';
    }
    if (/cv/.test(urlPath)) {
      return 'infos';
    }
  };

  const hoverEffect = (e) => {
    document
      .querySelectorAll(`.nav-menu .${e.currentTarget.classList[0]}`)
      .forEach((a) => {
        a.classList.add('active');
      });
  };

  const outEffect = (e) => {
    document
      .querySelectorAll(`.active`)
      .forEach((a) => a.classList.remove('active'));
  };

  const handleClickLink = (e) => {
    document
      .querySelectorAll('.focus-active')
      .forEach((linkFocus) => linkFocus.classList.remove('focus-active'));

    // if e nav menu [0] alors focus else if [1] alors select all add focus
    document
      .querySelectorAll(`.nav-menu .${e.currentTarget.classList[0]}`)
      .forEach((menuLink) => menuLink.classList.add('focus-active'));

    if (document.querySelector(`.${e.currentTarget.classList[1]}.imgLink`)) {
      document
        .querySelector(`.${e.currentTarget.classList[1]}.imgLink`)
        .classList.add('focus-active');
    }
  };

  useEffect(() => {
    document
      .querySelectorAll(`.nav-menu .${checkForNavLinkFocus()}`)
      .forEach((link) => link.classList.add('focus-active'));
    const navLinks = document.querySelectorAll('.nav-links a');

    navLinks.forEach((link) => {
      link.addEventListener('click', handleClickLink);
    });

    const allNav = document.querySelectorAll('.nav-menu a');
    allNav.forEach((a) => a.addEventListener('mouseover', hoverEffect));
    allNav.forEach((a) => a.addEventListener('mouseout', outEffect));

    return () => {
      allNav.forEach((a) => a.removeEventListener('mouseover', hoverEffect));
      allNav.forEach((a) => a.removeEventListener('mouseout', outEffect));
      navLinks.forEach((link) => {
        link.removeEventListener('click', handleClickLink);
      });
    };
  }, [urlPath]);
  // for mobil dropdown menu

  return (
    <>
      {!img ? (
        <NavFlex className={isBig ? 'hiden' : 'nav-links'}>
          <Link to="/" className="logo-link">
            <div>
              <ul className="logo-ul">
                <li>
                  Muriel Consigny P<span style={{ opacity: '0' }}>aysages</span>
                </li>

                <li>
                  M<span style={{ opacity: '0' }}>uriel</span> C
                  <span style={{ opacity: '0' }}>onsigny</span> Paysages
                </li>
              </ul>
            </div>
          </Link>
          <div className="nav-menu">
            <ul>
              <LiLink urlPath="realisations" textInsert="Réalisations" />
              <LiLink urlPath="etudes" textInsert="Études" />
              <LiLink urlPath="actualites" textInsert="Actualités" />
              <LiLink urlPath="infos" textInsert="À propos" />
            </ul>
          </div>
        </NavFlex>
      ) : (
        <NavFlex className={isBig ? 'hiden' : 'nav-links'}>
          <Link to="/" className="logo-link">
            <div className="logo-ul">
              <img src={logo} alt="" className="vignette" />
            </div>
          </Link>
          <div className="nav-menu">
            <ul>
              <LiLink urlPath="realisations" imgUrl={reaImg} />
              <LiLink urlPath="etudes" imgUrl={etudeImg} />
              <LiLink urlPath="actualites" imgUrl={actuImg} />
              <LiLink urlPath="infos" imgUrl={aboutImg} />
            </ul>
          </div>
        </NavFlex>
      )}
    </>
  );
}
